import { useLocation } from "react-router-dom";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useSupportWidgetContextV2 } from "../context/supportWidgetContext";
import BottomMenu from "./BottomMenu";
import HeaderBar from "./HeaderBar";

interface SupportWidgetContainerProps {
  children: React.ReactNode;
  onClose: () => void;
  pageName: string;
}

const BOTTOM_MENU_HEIGHT = 66;
const CONTAINER_PADDING = 16;
const TOTAL_OFFSET = BOTTOM_MENU_HEIGHT + CONTAINER_PADDING;

const SupportWidgetContainer = ({
  children,
  onClose,
  pageName,
}: SupportWidgetContainerProps) => {
  const { isExpanded } = useSupportWidgetContextV2();
  const location = useLocation();
  const isBottomMenuVisible = !location.pathname.match(
    /^\/conversations\/\d+$/,
  );
  return (
    <div
      className="rounded-2xl bg-white"
      style={{
        border: "4px solid rgba(228, 231, 235, 0.4)",
        boxShadow: `
        8px 14px 35px 0px rgba(110, 110, 110, 0.07),
        32px 54px 63px 0px rgba(110, 110, 110, 0.06),
        71px 122px 85px 0px rgba(110, 110, 110, 0.03),
        126px 218px 101px 0px rgba(110, 110, 110, 0.01),
        197px 340px 110px 0px rgba(110, 110, 110, 0)
      `,
      }}
    >
      <div
        className={classNames(
          "relative hidden h-[min(658px,calc(90vh))] min-h-[80px] origin-bottom-right overflow-hidden rounded-t-lg lg:flex lg:flex-col",
          {
            "w-[736px]": isExpanded,
            "max-h-[658px] w-[400px]": !isExpanded,
          },
        )}
        style={{
          transition:
            "width 200ms ease 0s, height 200ms ease 0s, max-height 200ms ease 0s, transform 300ms cubic-bezier(0, 1.2, 1, 1) 0s",
          ...(isExpanded && {
            height: `calc(100vh - ${TOTAL_OFFSET}px)`,
            maxHeight: `calc(100vh - ${TOTAL_OFFSET}px)`,
          }),
        }}
      >
        <div className="relative z-10 flex h-full w-full flex-col">
          <HeaderBar pageName={pageName} onClose={onClose} />
          {children}
        </div>
      </div>
      {isBottomMenuVisible && (
        <div
          className="border-primary hidden origin-bottom-right rounded-b-lg bg-white shadow-lg lg:flex"
          style={{ height: `${BOTTOM_MENU_HEIGHT}px` }}
        >
          <BottomMenu />
        </div>
      )}
    </div>
  );
};

export default SupportWidgetContainer;
